import { render, staticRenderFns } from "./returnOrderList.vue?vue&type=template&id=0f90c65a&"
import script from "./returnOrderList.vue?vue&type=script&lang=js&"
export * from "./returnOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports